import { useTranslation } from "react-i18next";

import { SchemaDefinition } from "shared/api/schemaDefinitions/types";

import { getAttributeValue } from "pages/shared/schemaDefinitions/utils";

import { SchemaEntry } from "features/ui/MaterialTable";

interface Props {
  fields: string[];
  item: Record<string, any>;
  getDisplayLabel: (accessor: string, defaultLabel: string) => string;
  getSchemaForAccessor: (accessor: string) => SchemaEntry | undefined;
  // When set, relation fields render as links to the related record, like in
  // the schema records table.
  schemaDefinition?: SchemaDefinition;
}

const HeaderFields = ({
  fields,
  item,
  getDisplayLabel,
  getSchemaForAccessor,
  schemaDefinition,
}: Props) => {
  const { t } = useTranslation("common");

  if (!fields || fields.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-row gap-8 flex-wrap ml-6">
      {fields.map((field) => {
        const schema = getSchemaForAccessor(field);
        const displayLabel = getDisplayLabel(field, schema?.label ?? field);

        return (
          <div
            key={field}
            data-testid={`header-field-${field}`}
            className="flex flex-col gap-1"
          >
            <div className="font-bold">{displayLabel}</div>
            <div>
              {getAttributeValue(
                field,
                item,
                getSchemaForAccessor,
                t,
                schemaDefinition
              ) ?? "-"}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default HeaderFields;
